import { OnlineStorage } from "@tblabs/storage";
import { Table, TextInput, Snack, Line, MultilineInput } from "@tblabs/truffle";
import { DangerButton } from "../Components/DangerButton";
import { Panel } from "../Components/Panel";
import { Page } from "./Page";
import { UserRef } from "../Models/UserRef";
import { PrimaryButton } from "../Components/PrimaryButton";
import { JsonEditor } from "../Components/JsonEditor";


export class UserEditPage extends Page
{
    constructor(private _storage: OnlineStorage, private userId: string)
    {
        super("User edit");
   
        this.Content(async (body) =>
        {
            const user = await this._storage.GetUser(this.userId);

            let availablePrivileges = "";
        
            try
            {
                const privileges = await this._storage.GetUserPrivilegesList();

                availablePrivileges = privileges.join("\n");
            }
            catch (ex: any)
            {
                availablePrivileges = "- user not allowed to see available privileges -";
            }

            const userRef = new UserRef(user);

            body.Append(
                new Panel("User " + this.userId.toUpperCase(), [
                    new Line(),
                    new PrimaryButton("Save").OnClick(async () => await this.SaveUser(userRef)),
                    new DangerButton("Delete").OnClick(async () => await this.DeleteUser(userRef)).MarginLeft(12),
                ]),
                new Panel("Fileds", [
                    new Table([], [
                        ["Name", new TextInput(userRef.Name)],
                        ["Email", new TextInput(userRef.Email)],
                        ["Role", new TextInput(userRef.Role)],
                        ["Icon", new TextInput(userRef.Icon)],
                        ["Login", new TextInput(userRef.Login)],
                        ["Password", new TextInput(userRef.Password)],
                        ["Privileges", new JsonEditor(userRef.Privileges)],
                        ["Available Privileges", new MultilineInput(availablePrivileges).Readonly().Rows(4).Background("#2c3c56").Color("#fff")],
                        ["Tags", new TextInput(userRef.Tags)],
                    ]).Class("uk-table")
                ]),
            );
        });
    }

    private async SaveUser(user: UserRef): Promise<void>
    {
        try
        {
            await this._storage.UpdateUser(user.AsRaw);
            
            new Snack("✅ User updated");

            window.location.hash = `admin/user/${user.Id}`;
        }
        catch (ex: any)
        {
            new Snack("❌ Failed to update user", ex.message);
        }
    }

    private async DeleteUser(user: UserRef): Promise<void>
    {
        try
        {
            if (confirm("Are you sure you want to delete this user?"))
            {
                await this._storage.DeleteUser(user.AsRaw);

                new Snack("✅ User deleted");

                window.location.hash = `admin/database`;
            }
        }
        catch (ex: any)
        {
            new Snack("❌ Failed to delete user", ex.message);
        }
    }
}
